import createAPI from "@/common/createApi.js"
/**
 * config: 接口参数，
 * vconfig: （自定义参数）{
 *  neverLoading: 是否显示loading
 * }
 */
export default {
  postTestServer: (realmName, config) =>
    createAPI(`/idaas/userFed/admin/realms/${realmName}/testLDAPConnection`, "post", config),
  postTestPassword: (realmName, config) =>
    createAPI(`/idaas/userFed/admin/realms/${realmName}/testLDAPConnection/auth`, "post", config),
  postRealmsUserContact:(realmName, config) =>
    createAPI(`/idaas/userFed/admin/realms/${realmName}/components`, "post", config),
  getRealmsUsersContact: (realmName, config) =>
    createAPI(`/idaas/userFed/admin/realms/${realmName}/components`, "get", config),
  deleteUserContactById: (realmName, userID ,config) =>
    createAPI(`/idaas/userFed/admin/realms/${realmName}/components/${userID}`, "delete", config),
  getRealmsUserContactById: (realmName, userID ,config) =>
    createAPI(`/idaas/userFed/admin/realms/${realmName}/components/${userID}`, "get", config),
  getUserContactAttribute: (realmName, userID ,config) =>
    createAPI(`/idaas/userFed/admin/realms/${realmName}/components/${userID}/mappers`, "get", config),
  putRealmsUserContact: (realmName, userID, config) =>
    createAPI(
      `/idaas/userFed/admin/realms/${realmName}/components/${userID}`,
      "put",
      config
    ),
  putRealmsUserContactMap: (realmName, userID, config) =>
    createAPI(
      `/idaas/userFed/admin/realms/${realmName}/components/${userID}/mappers`,
      "put",
      config
    ),
  postSyncUserContact:(realmName,userID, action ,config) =>
    createAPI(`/idaas/userFed/admin/realms/${realmName}/user-storage/${userID}/sync?action=${action}`, "post", config, {
      loadText: '用户同步中'
    }),
}